import React from "react";
import Footer from "../components/footer";
import NavBar from "../components/navbar";
import logo from "../friendsLogo.png";

export default function Root() {
  return (
    <div className="content fsa-body-bg">
      <NavBar />
      <div className="d-flex flex-column align-items-center justify-content-center flex-fill py-4 px-3">
        <div
          className="w-100 d-flex flex-column flex-md-row gap-4 align-items-center justify-content-center"
          style={{ maxWidth: 1200 }}
        >
          {/* Logo - full size */}
          <div
            className="d-flex align-items-center justify-content-center flex-grow-1"
            style={{ minWidth: 450 }}
          >
            <img
              className="img-fluid"
              src={logo}
              alt="Friends of St. Andrews State Park logo"
              style={{
                width: "100%",
                maxHeight: "85vh",
                height: "auto",
                borderRadius: "0.5rem",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Right column: membership card + QR below */}
          <div
            className="d-flex flex-column gap-4 flex-fill"
            style={{ minWidth: 380 }}
          >
            {/* Membership card */}
            <div className="card">
              <div className="card-header fsa-card-header">
                <h3
                  className="mb-0"
                  style={{
                    color: "white",
                    fontFamily: "inherit",
                    fontSize: "1.25rem",
                  }}
                >
                  Join Friends of St. Andrews State Park and receive:
                </h3>
              </div>
              <div className="card-body p-4">
                <ul
                  className="ps-3 mb-2"
                  style={{ fontSize: "1.05rem", lineHeight: "1.8" }}
                >
                  <li>
                    12 park entries for vehicles with up to eight occupants.
                  </li>
                  <li>Access to MEMBERS ONLY events.</li>
                  <li>
                    Invites to monthly Citizen Science Presentations in the
                    park.
                  </li>
                  <li>Notice of Special Park Events sponsored by Friends.</li>
                  <li>
                    Every membership dollar STAYS in the Park to benefit the
                    Park&apos;s mission.
                  </li>
                </ul>
                <a
                  className="btn btn-primary w-100"
                  href="/join"
                  style={{ fontSize: "1.05rem", padding: "0.75rem" }}
                >
                  Join Friends
                </a>
              </div>
            </div>

            {/* QR code below the card */}
            <div className="card">
              <div className="card-header fsa-card-header">
                <h5
                  className="mb-0"
                  style={{
                    color: "white",
                    fontFamily: "inherit",
                    fontSize: "1.15rem",
                  }}
                >
                  Support the Park
                </h5>
              </div>
              <div className="card-body d-flex flex-row align-items-center gap-4 p-4">
                <img
                  className="img-fluid flex-shrink-0"
                  src="/qr-code.png"
                  alt="Friends of St. Andrews State Park donation QR code"
                  style={{ width: 180, height: 180, objectFit: "contain" }}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
                <div className="d-flex flex-column gap-3">
                  <p className="mb-0" style={{ fontSize: "1rem" }}>
                    Scan or Click to donate to Friends of St. Andrews State
                    Park.
                  </p>
                  <a
                    className="btn btn-primary btn-lg"
                    href="/donations"
                    style={{ fontSize: "1rem" }}
                  >
                    Donate
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
